
export default[
    //改制列表
    {
        path: '/yuce/specificGyList',
        component: () => import( '@/views/loud/yuce/specificGyList.vue'),
        meta: {
            title: '工艺改制审核人',
            isTabsPage: true
        }
    },
]
